import pino from 'pino';

// Logger instance, is setup to push logs to monitoring services
export const logger = pino({
  browser: {
    asObject: true,
  },
});
